var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { FileUploadPreview } from "../utils/FileUploadPreview";
export var LeagueForm = function (_a) {
    var league = _a.league, onSubmit = _a.onSubmit;
    var _b = useForm(), control = _b.control, handleSubmit = _b.handleSubmit, setValue = _b.setValue, errors = _b.formState.errors;
    var handleLogoChange = function (base64) {
        setValue("logo", base64);
    };
    return (_jsxs(Box, { component: "form", onSubmit: handleSubmit(onSubmit), noValidate: true, role: "form", sx: { mt: 2 }, children: [_jsx(Controller, { name: "name", control: control, defaultValue: (league === null || league === void 0 ? void 0 : league.name) || "", rules: { required: "League Name is required" }, render: function (_a) {
                    var field = _a.field;
                    return (_jsx(TextField, __assign({}, field, { margin: "normal", required: true, fullWidth: true, id: "name", label: "League Name", autoComplete: "leagueName", autoFocus: true, error: !!errors.name, helperText: errors.name ? errors.name.message : "" })));
                } }), _jsx(Controller, { name: "description", control: control, defaultValue: (league === null || league === void 0 ? void 0 : league.description) || "", render: function (_a) {
                    var field = _a.field;
                    return (_jsx(TextField, __assign({}, field, { margin: "normal", fullWidth: true, id: "description", label: "Description", multiline: true, minRows: 3 })));
                } }), _jsx(FileUploadPreview, { label: "Logo", onChange: handleLogoChange }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, children: league === undefined ? "Create" : "Update" })] }));
};
